import http from '../../utils/fetch';
import updownfile from '../../utils/updownfile';

const basePath = '/api/swyl/v1/abnormal/apply';

export default {
    save(data) {
        return http({
            url: `${basePath}/save`,
            method: 'post',
            data: data
        });
    },
    submit(data) {
        return http({
            url: `${basePath}/submit`,
            method: 'post',
            data: data
        });
    },
    resubmit(data) {
        return http({
            url: `${basePath}/resubmit`,
            method: 'post',
            data: data
        });
    },
    withdraw(id) {
        return http({
            url: `${basePath}/withdraw`,
            method: 'post',
            data: { id }
        });
    },
    page(data) {
        return http({
            url: `${basePath}/page`,
            method: 'post',
            data: data
        });
    },
    detail(id) {
        return http({
            url: `${basePath}/detail/${id}`,
            method: 'get'
        });
    },
    approve(data) {
        return http({
            url: `${basePath}/approve`,
            method: 'post',
            data: data
        });
    },
    exportExcel(params) {
        updownfile.down(`${basePath}/export`, params, 'get');
    }
}
